import React from 'react';
import styles from './A_BenefitItem.module.css';
import cn from 'classnames';

interface A_BenefitItemProps {
  image: React.ReactNode;
  description: string;
}

export default function A_BenefitItem({
  image,
  description,
}: A_BenefitItemProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.image_wrapper}>{image}</div>
      <p className={cn(styles.description, 'text-p-7')}>{description}</p>
    </div>
  );
}
